"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@apollo/client/core");
var baseImage_1 = require("../baseImage");
var price_1 = require("../price");
var dealFeature = {
    DEAL_FEATURE: core_1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    ", "\n\n    fragment DealFeature on DealFeature {\n      id\n      shortname\n      code\n      categoryCode\n      image {\n        ...BaseImage\n      }\n      prices {\n        ...Price\n      }\n    }\n  "], ["\n    ", "\n    ", "\n\n    fragment DealFeature on DealFeature {\n      id\n      shortname\n      code\n      categoryCode\n      image {\n        ...BaseImage\n      }\n      prices {\n        ...Price\n      }\n    }\n  "])), baseImage_1.default.BASE_IMAGE, price_1.default.PRICE),
};
exports.default = dealFeature;
var templateObject_1;
